// extracted by mini-css-extract-plugin
export default {"Accordion":"styles_Accordion__+JNKj","header":"styles_header__rPtLJ","content":"styles_content__FCxKr"};